module.exports = __webpack_public_path__ + "img/publick_code.46a91482.jpg";